import { authAxios } from '@/axios/axios';

const RESERVATION_MESSAGING_API_BASE_PATH = "/reservations/";

export const getReservation = async (id) => {
    const { data } = await authAxios.get(`reservations/${id}`);
    return data;
}

export const getReservations = async (params) => {
    const { data } = await authAxios.get("reservations/", {
        params,
    });
    return data;
}

export const getReservationsFile = async (params) => {
    const { data } = await authAxios.get("reservations/file/", {
        params,
    });
    return data;
}

export const getReservationsByDate = async date => {
    const { data } = await authAxios.get(`reservations/filtered-reservations/?date=${date}`);
    return data;
}

export const getReservationsByMonth = async (month, year) => {
    const { data } = await authAxios.get(`reservations/filtered-reservations/?month=${month}&year=${year}`);
    return data;
}

export const getReservationsCountByMonth = async (month, year) => {
    const { data } = await authAxios.get(`reservations/filtered-reservations/count/?month=${month}&year=${year}`);
    return data;
}

export const postReservation = async (reservation) => {
    const { data } = await authAxios.post("reservations/", reservation);
    return data;
}

export const patchReservation = async ({ id, reservation }) => {
    const { data } = await authAxios.patch(`reservations/${id}/`, reservation);
    return data;
}

export async function getReservationBestTables({
    duration,
    startTime,
    partySize,
    ignoredReservations,
    greedy,
    zone,
    referenceDatetime,
}) {
    const { data } = await authAxios.get(
        `reservation/availability/best-tables/`,
        {
            params: {
                duration,
                start_time: startTime,
                party_size: partySize,
                ignored_reservations: ignoredReservations,
                greedy,
                zone,
                reference_datetime: referenceDatetime,
            },
        }
    );
    return data;
}

// Create a new ChatThread for the reservation and add the content as the first message from the restaurant. 
// If the reservation has a comment it will be added as the first message from the customer
export async function postReservationChatThread(reservationId, content) {
    const url = `${RESERVATION_MESSAGING_API_BASE_PATH}${reservationId}/chat-thread/`;
    const res = await authAxios.post(url, { content });
    return res.data;
}


// WEBPACK FOOTER //
// ./src/queries/reservations/requests.js